import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import Tag from '~/shared/components/tags/Tag'
import theme from '~/shared/styles/theme'

type Props = {
  caution: {
    event_caution_note: string
    event_caution_etc: string
  }
}

function Caution({ caution }: Props) {
  const navigate = useNavigate()

  return (
    <Wrapper>
      <Title>행사 주의사항</Title>
      <Tag $size={'md'} $variant={'gray'}>
        주의사항
      </Tag>
      <Desc>{caution.event_caution_note}</Desc>
      <Button onClick={() => navigate('/customer-service/inquiry')}>
        1:1 문의하기
      </Button>
      <Tag $size={'md'} $variant={'gray'}>
        기타사항
      </Tag>
      <Desc>{caution.event_caution_etc}</Desc>
    </Wrapper>
  )
}

export default Caution

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  height: auto;
  padding: 36px 24px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;
`
const Title = styled.h2`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 500;
`
const Desc = styled.p`
  font-size: 18px;
  line-height: 140%;
  color: #313634;
`

const Button = styled.button`
  cursor: pointer;

  width: 136px;
  height: 48px;

  /* padding: 11px 20px; */

  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 18px;
  color: ${theme.colors.grey_5};

  background-color: white;
  border: 1px solid #313634;
  border-radius: 50px;
`
